import { Editor } from '@tiptap/react';
import { isEmpty } from 'lodash';

/**
 * The method calculates the coordinates of the '+' icon in the rich text editor.
 * The coordinates are calculated so that the '+' icon to be always
 * at the beginning of new line
 * @param editor ref to the current Editor instance
 */

export const findAddMenuPosition = (
  editor: Editor,
): { top: number; left: number } | null => {
  if (!isStartOfEmptyLine(editor)) {
    return null;
  }

  const { view } = editor;
  const cursorCoords = view.coordsAtPos(editor.state.selection.to);
  const editorRect = view.dom.getBoundingClientRect();

  const top = cursorCoords.top - editorRect.top + 8;

  return { top, left: 0 };
};

export const isStartOfEmptyLine = (editor: Editor): boolean => {
  const { view } = editor;
  const cursorCoords = view.coordsAtPos(editor.state.selection.to);
  const editorRect = view.dom.getBoundingClientRect();
  return (
    cursorCoords.left === editorRect.left &&
    isEmpty(editor.state.selection.$anchor.parent.textContent)
  );
};
